<ion-header>
  <ion-toolbar color="primary" no-border-bottom>
    <ion-buttons slot="start">
      <img class="icon-ai" [src]="'./assets/images/icons/ai.png'">
    </ion-buttons>
    <ion-title>
      {{ 'APP.TITLE.AiProcessing' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content padding>
  <ion-grid>
    <ion-row>
      <ion-col class="text-center">
        <ion-list [inset]="false">
          <ng-container *ngFor="let photo of photos">
            <send-photo-ai
              [id]="photo.id"
              [photoPlaceholder]="photoPlaceholder"
              (onProcessed)="onProcessed($event)"
              (onError)="onError($event)">
            </send-photo-ai>
          </ng-container>
        </ion-list>

      </ion-col>
    </ion-row>
    <ion-row class="mt-5" *ngIf="!error && !isDone()">
      <ion-col class="text-center">
        <ion-spinner name="circular" color="medium" *ngIf="!isDone()"></ion-spinner>

        <span *ngIf="isDone() && !error">DONE!</span>
      </ion-col>
    </ion-row>
    <ion-row class="mt-5" *ngIf="error">
      <ion-col class="">
        <div class="alert alert-danger">
          <!-- <pre>{{ errorData | json }}</pre> -->
          {{ errorMessage }}
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
